<template>
  <div class="app-container bj-label-colon label-width-6 bj-el-input-disabled">
    <BjDivider right-fixed>{{ $t('DetailsOfThirdPartySalesOrder.Order') }}
      <template slot="right">
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
        <el-button v-if="!$store.getters.cusId" type="primary" @click="showLog">{{ $t('DetailsOfThirdPartySalesOrder.log') }}</el-button>
      </template>
    </BjDivider>
    <div class="bj-row mt20">
      <!-- 正常流转状态 -->
      <template v-if="orderInfoVO.circulationStatus == 0">
        <div class="bj-col bj-col-14 circulation-status">
          <div class="el-icon-circle">
            <i class="el-icon-circle-check" />
          </div>
          <div>
            <div class="bj-form-item">
              <div class="bj-formItemLabel auto-width">{{ $t('DetailsOfThirdPartySalesOrder.Circulation') }}</div>
              <div class="bj-form-item-value">{{ $t('DetailsOfThirdPartySalesOrder.Normal') }}</div>
            </div>
            <div class="bj-form-tips">{{ $t('DetailsOfThirdPartySalesOrder.party') }}</div>
          </div>
        </div>
      </template>
      <!--暂停流转 状态 -->
      <template v-if="orderInfoVO.circulationStatus == 1">
        <div class="bj-col bj-col-14 circulation-status">
          <div class="el-icon-circle">
            <i class="el-icon-warning-outline"></i>
          </div>
          <div>
            <div class="bj-form-item">
              <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.Circulation') }}</div>
              <div class="bj-form-item-value">{{ $t('DetailsOfThirdPartySalesOrder.Suspend') }}</div>
            </div>
            <div class="bj-form-item">
              <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.Reason') }}</div>
              <div class="bj-form-item-value">{{ $t(LANG_ZH_EN_PS_LIST.bjGet(orderInfoVO.failureReason)) }}</div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="bj-row mt20">
      <div class="bj-col bj-col-12">
        <div class="bj-form-title">
          {{ $t('DetailsOfThirdPartySalesOrder.information') }}
          <span v-if="!isOrderInfoVOEdit && orderInfoVO.circulationStatus == '1' && $route.query.type!='view' && !isReciverEdit" class="link right" @click="showOrderInfoVOEdit">{{ $t('InternalSalesOrderDetails.Modify') }}</span>
          <span v-if="isOrderInfoVOEdit" class="link right" style="margin-left:10px;" @click="saveOrderInfoVO">{{ $t('saveText') }}</span>
          <span v-if="isOrderInfoVOEdit" class="link right" @click="cancelOrderInfoVOEdit">{{ $t('cancelText') }}</span>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.Trantypesaction') }}</div>
          <div class="bj-form-item-value">
            {{ $t(ORDER_BUSINESS_TYPE_LIST.bjGet(orderInfoVO.businessType)) }}
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.number') }}</div>
          <div class="bj-form-item-value">
            <span>{{ orderInfoVO.webReference }}</span>
            <BjCopyIcon :copy="orderInfoVO.webReference" />
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.Sales') }}</div>
          <div class="bj-form-item-value">
            {{ orderInfoVO.storeName }}
            <span class="F68710">（{{ SCHL_CHANNEL_TYPE.bjGet(orderInfoVO.channel) }}）</span>
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.OrderDate') }}</div>
          <div class="bj-form-item-value">
            <span>{{ orderInfoVO.orderTime | timeFilters(orderInfoVO.orderTime) }}</span>
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.pulling') }}</div>
          <div class="bj-form-item-value">{{ orderInfoVO.creationDate | timeOperateTwoHour(orderInfoVO.creationDate) }}</div>
        </div>
        <div v-if="orderInfoVO.shippingMethod == 'CSG MANUAL'" class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('BusinessThirdOrderAdd.deliveryAppointmentTime') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isOrderInfoVOEdit">{{ orderInfoVO.deliveryAppointmentTime | timeFilters(orderInfoVO.deliveryAppointmentTime) }}</span>
            <BjDateTimerPicker v-else v-model="orderInfoVO.deliveryAppointmentTime" />
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('SalesOrderToBeApproved.Merchant') }}</div>
          <div class="bj-form-item-value" :class="{ 'order-remark-content': !isOrderInfoVOEdit }">
            <template v-if="!isOrderInfoVOEdit">
              <el-tooltip effect="dark" :content="orderInfoVO.orderRemarks" :disabled="!orderInfoVO.orderRemarks" placement="top-start" popper-class="csg-order-remark-tooltip">
                <span class="ellipsis order-remark-text">{{ orderInfoVO.orderRemarks }}</span>
              </el-tooltip>
              <BjCopyIcon v-if="orderInfoVO.orderRemarks" class="link order-remark-copy" :copy="orderInfoVO.orderRemarks" />
            </template>
            <BjInput v-else v-model="orderInfoVO.orderRemarks" :maxlength="MAX_LENGTH.PRIORITY" :placeholder="$t('inputText')" />
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('RefundOnlyToBeReviewed.form.service') }}</div>
          <div class="bj-form-item-value" :class="{ 'order-remark-content': !isOrderInfoVOEdit }">
            <template v-if="!isOrderInfoVOEdit">
              <el-tooltip effect="dark" :content="orderInfoVO.serviceRemarks" :disabled="!orderInfoVO.serviceRemarks" placement="top-start" popper-class="csg-order-remark-tooltip">
                <span class="ellipsis order-remark-text">{{ orderInfoVO.serviceRemarks }}</span>
              </el-tooltip>
              <BjCopyIcon v-if="orderInfoVO.serviceRemarks" class="link order-remark-copy" :copy="orderInfoVO.serviceRemarks" />
            </template>
            <BjInput v-else v-model="orderInfoVO.serviceRemarks" :maxlength="MAX_LENGTH.PRIORITY" :placeholder="$t('inputText')" />
          </div>
        </div>
        <div class="bj-form-item" v-if="orderInfoVO.storeCode == 'CO00000658'">
          <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.dodgeCompany') }}</div>
          <div class="bj-form-item-value">{{ orderInfoVO.ecommerceOrderRef}}</div>
        </div>
        <div class="bj-form-item" v-if="orderInfoVO.storeCode == 'CO00000658'">
          <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.dodgeAccount') }}</div>
          <div class="bj-form-item-value">{{ orderInfoVO.siteListingId}}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('BusinessPurchaseOrder2.means') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isOrderInfoVOEdit">{{ orderInfoVO.shippingMethod !== 'PICKUP' && orderInfoVO.isLogisticsSpecified && orderInfoVO.logisticsName ? orderInfoVO.shippingMethod + ' (' + orderInfoVO.logisticsName + ')' : orderInfoVO.shippingMethod }}</span>
            <BjSelectLov v-else v-model="orderInfoVO.shippingMethod" :option-list="CSG_ORDER_SHIPPING_METHODS_LIST" @change="onShippingMethod" />
          </div>
        </div>
        <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL' || orderInfoVO.shippingMethod=='CSG MANUAL'" class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.chooseLogistics') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isOrderInfoVOEdit">{{ orderInfoVO.logisticsBusinessName }}</span>
            <BjSelectLov v-else v-model="orderInfoVO.logisticsBusinessName" :disabled="!isOrderInfoVOEdit" :option-list="LogisticsSelectionData" @change="logsome" />
          </div>
        </div>
        <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL' || orderInfoVO.shippingMethod=='CSG MANUAL'" class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('OrdinaryOrderMix.LogisticsTable.logisticsNo') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isOrderInfoVOEdit">{{ orderInfoVO.logisticsNo }}</span>
            <BjInput v-else v-model="orderInfoVO.logisticsNo" :disabled="!isOrderInfoVOEdit" clearable />
          </div>
        </div>
        <!-- 'CUSTOMER MANUAL' 是否需要仓库提供尺寸信息 -->
        <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'" class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.check') }}</div>
          <div class="bj-form-item-value">
            <el-switch v-model="orderInfoVO.isProvideSize" :disabled="!isOrderInfoVOEdit" active-color="#082dc3" inactive-color=""></el-switch>
          </div>
        </div>
        <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'" class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.need') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isOrderInfoVOEdit">{{ orderInfoVO.palletQty }}</span>
            <BjInputNumber v-else v-model="orderInfoVO.palletQty" :disabled="!isOrderInfoVOEdit" clearable />
          </div>
        </div>
        <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'" class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.time') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isOrderInfoVOEdit">{{ orderInfoVO.truckPickupTime }}</span>
            <BjDateTimerPicker v-else v-model="orderInfoVO.truckPickupTime" :disabled="!isOrderInfoVOEdit" />
          </div>
        </div>
        <!-- 物流单  || (isOrderInfoVOEdit && !$store.getters.cusId)-->
        <template v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL' && !isOrderInfoVOEdit">
          <div class="file">
            <div class="bj-formItemLabel">{{ $t('OrdinaryOrderMix.LogisticsTable.Shipment') }}</div>
            <div class="fileUpload">
              <div v-for="(item, index) in info.orderInfoVO.shippingLabels" :key="index" class="fileUpload_right">
                <div class="ellipsis link" @click="downloadImageUrl(item.url, item.name)"><span>file{{ index + 1 }}: </span> {{ item.name }}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 上传物流单  && $store.getters.cusId-->
        <template v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL' && isOrderInfoVOEdit">
          <div class="font12">
            <div class="bj-formItemLabel">{{ $t('OrdinaryOrderMix.LogisticsTable.Shipment') }}:</div>
          </div>
          <div class="fileUpload2">
            <UploadFile ref="UploadFileRef1" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" multiple show-file-list accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx" :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.xlsx']" auto-upload limit-hide @handleFileListChange="fileListChange1">
              <template slot="default">
                <el-button size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
              </template>
            </UploadFile>
          </div>
        </template>
        <!-- 附件 -->
        <template v-if="!isOrderInfoVOEdit || (isOrderInfoVOEdit && !$store.getters.cusId)">
          <div class="file" style="margin-top:10px">
            <div class="bj-formItemLabel">{{ $t('OrdinaryOrderMix.LogisticsTable.Supporting') }}:</div>
            <div class="fileUpload">
              <div v-for="(item, index) in info.orderInfoVO.orderMaterialList" :key="index" class="fileUpload_right">
                <div class="ellipsis link" @click="downloadImageUrl(item.fileUrl, item.fileName)"><span>file{{ index + 1 }}: </span> {{ item.fileName }}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 上传附件 -->
        <template v-if="isOrderInfoVOEdit && $store.getters.cusId">
          <div class="font12">
            <div class="bj-formItemLabel">{{ $t('OrdinaryOrderMix.LogisticsTable.Supporting') }}:</div>
          </div>
          <div class="fileUpload2">
            <UploadFile ref="UploadFileRef2" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" multiple show-file-list accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx" :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.xlsx']" auto-upload limit-hide @handleFileListChange="fileListChange2">
              <template slot="default">
                <el-button size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
              </template>
            </UploadFile>
          </div>
        </template>
      </div>

      <!-- 买家及收货信息 新-->
      <buyerInfoDialog v-if="$route.query.status=='2'" :is-show-edit="orderInfoVO.circulationStatus != 0 && $route.query.type!='view' && !isOrderInfoVOEdit" :receiver-info-v-o="info.receiverInfoVO" @saveReceiverInfo="saveReceiverInfo" />
      <!-- 买家及收货信息 旧-->
      <receivingInformation v-else :is-show-edit="orderInfoVO.circulationStatus != 0 && $route.query.type!='view' && !isOrderInfoVOEdit" :receiver-info-v-o="info.receiverInfoVO" :is-reciver-edit="isReciverEdit" @onEditReceiverInfo="onEditReceiverInfo" @saveReceiverInfo="saveReceiverInfo" @cancelReceiverInfo="cancelReceiverInfo" />
    </div>

    <div class="bj-row mt20">
      <div class="bj-col bj-col-24">
        <el-tabs v-model="activeName" type="card">
          <!-- 商品清单 -->
          <el-tab-pane :label="$t('DetailsOfThirdPartySalesOrder.Commodity')" name="first">
            <div>
              <!-- <div style="float: left;line-height: 2;margin-right: 30px;" class="bj-form-title">{{ $t('DetailsOfThirdPartySalesOrder.Commodity') }}</div> -->
              <div style="float: left;margin-bottom: 10px;">
                <el-button v-if="isShow" :disabled="SELECTED_BJ_EBC_ID.length == 0" type="danger" @click="onBatchDelete">{{ $t('SalesOrderEntry.delete') }}</el-button>
                <el-button v-if="isShow" type="primary" @click="onAddSome">{{ $t('SalesOrderEntry.ordinary') }}</el-button>
                <el-button v-if="isShow" type="primary" @click="onAddMore">{{ $t('SalesOrderEntry.package') }}</el-button>
              </div>
              <div style="float: right;">
                <el-button v-if="!isShow && orderInfoVO.circulationStatus == '1' && $route.query.type!='view'" type="text" @click="isShow = !isShow">{{ $t('editText') }}</el-button>
                <el-button v-if="isShow" type="text" @click="isShow = !isShow;reFresh()">{{ $t('cancelText') }}</el-button>
                <el-button v-if="isShow" type="text" @click="onSave">{{ $t('saveText') }}</el-button>
              </div>
            </div>
            <el-table :data="thirdItemVO" stripe border :row-style="rowStyleFun" @selection-change="handleSelectionChange">
              <el-table-column v-if="isShow" type="selection" width="55" align="center"></el-table-column>
              <el-table-column type="index" :label="$t('DetailsOfThirdPartySalesOrder.Serial')" align="center" width="60" />
              <el-table-column prop="innerSkuCode" :label="$t('ExternalOrders.newAdd.ProductSKU')" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.innerSkuCode?scope.row.standardSkuCode:'' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="innerSkuName" :label="$t('ExternalOrders.newAdd.ProductName')" show-overflow-tooltip align="center" />
              <el-table-column prop="standardSkuCode" :label="$t('ExternalOrders.newAdd.ExternalSku')" show-overflow-tooltip align="center" />
              <el-table-column prop="quantity" :label="$t('DetailsOfThirdPartySalesOrder.Quantity')" align="center">
                <template slot-scope="scope">
                  <span v-if="!isShow">{{ scope.row.quantity }}</span>
                  <BjInputNumber v-else v-model="scope.row.quantity" />
                </template>
              </el-table-column>
              <el-table-column prop="spuCode" :label="$t('OrdinaryOrderMix.OrderItemTable.SPU')" align="center">
                <template slot-scope="scope">
                  <span v-if="!isShow">{{ scope.row.spuCode }}</span>
                  <BjSelectLov v-else v-model="scope.row.spuCode" :option-list="scope.row.batchNumList" :placeholder="$t('OrdinaryOrderMix.OrderItemTable.SPU')" clearable />
                </template>
              </el-table-column>
              <el-table-column :label="$t('BusinessBatchInventoryQuery.table.usableNum2')" prop="usableNum" align="center">
                <template slot-scope="scope">
                  <span v-if="!scope.row.spuCode && orderInfoVO.failureReason == '批次库存不足'">{{ scope.row.batchNumList && scope.row.batchNumList.length>0 ? scope.row.batchNumTotal:'' }}</span>
                  <span v-else-if="scope.row.spuCode && scope.row.batchNumList && scope.row.batchNumList.length>0">{{ scope.row.batchNumList.bjGet(scope.row.spuCode, 'value', 'usableNum') }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('BusinessThirdOrderAdd.form.Operation')" align="center" fixed="right" width="120">
                <template slot-scope="scope">
                  <el-button :disabled="!isShow" type="text" @click="onDelete(scope.row)">{{ $t('delText') }}</el-button>
                  <el-button v-if="orderInfoVO.failureReason == '批次库存不足' && !scope.row.spuCode" type="text" @click="onView(scope.row)">{{ $t('viewText') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="bj-form-tips" style="margin-top: 15px">
              {{ $t('DetailsOfThirdPartySalesOrder.Totalproducts') }}{{ totalSkuNum }} ，{{ $t('DetailsOfThirdPartySalesOrder.Totalnumber') }}{{ thirdItemVO.length }}
            </div>
          </el-tab-pane>
          <!-- 包材信息 -->
          <el-tab-pane :label="$t('goodsPage.package.Info')" name="second" v-if="this.$store.state.user.permissionBtns.includes('BusinessGoodsPackageManagement'.toLocaleLowerCase())">
            <el-table :data="packageVO" stripe border :header-cell-style="$rowStyle.DEFAULT">
              <el-table-column :label="$t('table.countText')" type="index" width="60" align="center" />
              <el-table-column prop="packingMethod" :label="$t('goodsPage.packingM')" show-overflow-tooltip align="center">
                  <template slot-scope="scope">{{ $t(PACKAGE_TYPE_LIST.bjGet(scope.row.packingMethod)) }}</template>
              </el-table-column>
              <el-table-column prop="skuName" :label="$t('goodsPage.package.Name')" show-overflow-tooltip align="center" />
              <el-table-column prop="skuCode" :label="$t('goodsPage.package.SKU')" show-overflow-tooltip align="center" />
              <el-table-column prop="packageCount" :label="$t('goodsPage.package.num')" show-overflow-tooltip align="center">
                  <template slot-scope="scope">{{ scope.row.packageCount }}</template>
              </el-table-column>
              <el-table-column prop="salesPriceSum" :label="$t('goodsPage.package.money1')" show-overflow-tooltip align="center">
                  <template slot-scope="scope">{{ scope.row.salesPriceSum }}</template>
              </el-table-column>
              <el-table-column prop="activityPriceSum" :label="$t('goodsPage.package.money2')" show-overflow-tooltip align="center">
                  <template slot-scope="scope">{{ scope.row.activityPriceSum }}</template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 物流信息 ==> 已完成订单5 展示-->
    <div v-if="totalOrderStatus==5" class="bj-row mt20">
      <div class="bj-col bj-col-24">
        <div style="float: left;line-height: 2;margin-right: 30px;" class="bj-form-title">{{ $t('InternalSalesOrderDetails.Logistics') }}</div>
        <el-table :data="[orderInfoVO]" stripe border :header-cell-style="$rowStyle.DEFAULT">
          <el-table-column prop="webReference" :label="$t('InternalSalesOrderDetails.party')" align="center" />
          <el-table-column prop="logisticsNo" :label="$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')" align="center" />
          <el-table-column prop="logisticsCompany" :label="$t('OrdinaryOrderMix.LogisticsTable.logisticsCompany')" align="center" />
          <el-table-column prop="logisticsBusinessName" :label="$t('OrdinaryOrderMix.LogisticsTable.logisticsBusinessName')" align="center" width="200" />
          <el-table-column v-if="!$store.getters.cusId" prop="totalPrice" :label="$t('OrdinaryOrderMix.LogisticsTable.totalPrice')" align="center">
            <template slot-scope="scope">{{ scope.row.totalPrice ? (scope.row.totalPrice-0).toFixed(2) : scope.row.totalPrice }}</template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 物流询价 ==> (新订单1 或者 异常订单2)并且storeCode=='CO00000200' 展示-->
    <div v-if="(totalOrderStatus== 1||totalOrderStatus==2)&&isLogisticsShow" class="bj-row mt20">
      <div class="bj-col bj-col-24">
        <div style="float: left;line-height: 2;margin-right: 30px;" class="bj-form-title">{{ $t('OrdinaryOrderMix.LogisticsTable.PriceSearchResults') }}</div>
        <el-table :data="logisticsInfo" stripe border :header-cell-style="$rowStyle.DEFAULT">
          <el-table-column align="center" prop="provider" :label="this.$t('InternalSalesOrderDetailsSearchTable.providerss')"></el-table-column>
          <el-table-column align="center" prop="ratePrice" :label="this.$t('billingPage.ratePrice')">
            <template slot-scope="scope">{{ scope.row.ratePrice ? (scope.row.ratePrice-0).toFixed(2) : scope.row.ratePrice }}</template>
          </el-table-column>
          <el-table-column align="center" prop="responseCode" :label="this.$t('InternalSalesOrderDetailsSearchTable.responseCode')">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top" :content="scope.row.responseMsg" :disabled="!scope.row.responseMsg">
                <div slot="reference" class="name-wrapper">
                  {{ scope.row.responseCode }}
                  <i v-if="scope.row.responseCode=='FAILED'" class="el-icon-warning" style="color:red"></i>
                </div>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 选择普通商品 -->
    <BjDialogList ref="dialogListOrdinarySku" width="80%" :config="$BjDialogListConfig.skuDefault($t('SalesOrderEntry.goods'),{
          defaultQuery: { cusId: info.cusId, setFlag: 0, status: [3, 4, 5], itemType:'item' }})" multiple @confirm="onAddGoodsDialogConfirm" />
    <BjDialogList ref="dialogListPackAgeSku" width="80%" :config="$BjDialogListConfig.skuDefault($t('SalesOrderEntry.Add'), {
          defaultQuery: { cusId: info.cusId, setFlag: 1, status: [3, 4, 5] }})" multiple @confirm="onAddGoodsDialogConfirm" />

    <el-dialog :visible.sync="barcodeVisible" width="500px">
        <el-table :data="barcodeList" border script max-height="600px">
          <el-table-column prop="standardSkuCode" :label="$t('ExternalOrders.newAdd.ProductSKU')" align="center" />
          <el-table-column prop="label" :label="$t('OrdinaryOrderMix.OrderItemTable.SPU')" align="center" />
          <el-table-column prop="usableNum" :label="$t('BusinessBatchInventoryQuery.table.usableNum2')" align="center" />
        </el-table>
    </el-dialog>
  </div>
</template>
  <script>
  import viewMiXin from '@/utils/view-mixin.js';
  import { orderApi, afterApi, logisticApi, thirdApi, userApi } from '@/api';
  import orderLog from '@/utils/log.js';
  import receivingInformation from '@/components/order/receivingInformation';
  import buyerInfoDialog from '@/components/order/buyerInfoDialog';
  import UploadFile from './UploadFile';
  import moment from 'moment';
  import { ORDER_BUSINESS_TYPE_LIST, LANG_ZH_EN_PS_LIST,PACKAGE_TYPE_LIST } from '@/utils/constants';
  import { getShippingList } from '@/utils/index';

  const getDefaultForm = () => {
    return {
      amountInfoVO: {
        amountReceivable: null,
        businessDiscountAmount: null,
        buyerPayAmount: null,
        thirdDiscountAmount: null,
        totalAmount: null,
        totalDiscount: null,
      },
      orderInfoVO: {
        businessType: 'common',
        buyerNick: null,
        buyerRemarks: null,
        channel: null,
        channelTypeMeaning: null,
        circulationStatus: null,
        creationDate: null,
        failureReason: null,
        id: null,
        innerOrderNo: null,
        orderRemarks: null,
        orderStatus: null,
        orderTime: null,
        deliveryAppointmentTime: null,
        outerOrderNo: null,
        payTime: null,
        receivingStatus: null,
        refundStatus: null,
        salesEmployeeId: null,
        salesEmployeeRealName: null,
        serviceRemarks: null,
        storeName: null,
        takingDeliveryStoreId: null,
        takingDeliveryStoreName: null,
        takingDeliveryWay: null,
        shippingMethod: null,
        // 运单文件
        shippingLabels: [],
        // 其他文件
        orderMaterialList: [],
        isLogisticsSpecified: false,
        logisticsName: null,
        isProvideSize: false,
        palletQty: null,
        truckPickupTime: null,
        logisticsBusinessName: null,
        logisticsNo: null,
        logisticsCompany: null
      },
      paymentInfoVO: {
        payAmount: null,
        payStatus: null,
        payTime: null,
        payType: null,
      },
      receiverInfoVO: {
        address: null,
        addressMask: null,
        buyerNick: null,
        city: null,
        cityCode: null,
        comments: null,
        deliveryAddress1: null,
        deliveryAddress2: null,
        deliveryEmailAddress: null,
        district: null,
        districtCode: null,
        mobile: null,
        phone: null,
        province: null,
        provinceCode: null,
        receiverName: null,
        receiverNameMask: null,
        receiverPhoneMask: null,
        shippingType: null,
      },
      thirdItemVO: [
        {
          businessDiscountAmount: null,
          changeAmount: null,
          deleteFlag: null,
          discountAmount: null,
          exceptionFlag: false,
          exceptionReason: null,
          giftFlag: null,
          goodsImg: null,
          id: null,
          innerOrderNo: null,
          innerSkuCode: null,
          innerSkuName: null,
          innerSpuCode: null,
          outerItemId: null,
          outerOrderNo: null,
          outerSaleAmount: null,
          outerSingleSaleAmount: null,
          payAmount: null,
          postage: null,
          quantity: null,
          refundAmount: null,
          refundCount: null,
          refundNo: null,
          setFlag: null,
          skuCode: null,
          skuId: null,
          skuName: null,
          spuCode: null,
          spuId: null,
          spuName: null,
          thirdDiscountAmount: null,
        },
      ],
      packageVO:[
        {
          activityPriceSum:null,
          packageCount:null,
          packingMethod:null,
          salesPriceSum:null,
          skuCode:null,
          skuName:null,
        }
      ],
    };
  };

  export default {
    name: 'BusinessThirdOrderViewForm',
    components: {
      receivingInformation,
      buyerInfoDialog,
      UploadFile
    },
    mixins: [viewMiXin],
    data() {
      return {
        CSG_ORDER_SHIPPING_METHODS_LIST: [],
        ORDER_BUSINESS_TYPE_LIST,
        LANG_ZH_EN_PS_LIST,
        PACKAGE_TYPE_LIST,
        info: getDefaultForm(),
        originalIsLogisticsSpecified: 0,
        isReciverEdit: false,
        isOrderInfoVOEdit: false,
        copyReceiverInfo: {},
        copyOrderInfoVO: {},
        // manual: ['CSG MANUAL', 'CUSTOMER MANUAL'],
        isShow: false,
        multipleSelection: [],
        // 订单总状态
        totalOrderStatus: '',
        // 物流询价相关信息
        logisticsInfo: [],
        // 是否显示物流询价
        isLogisticsShow: false,
        // 物流列表信息
        LogisticsSelectionData: [],
        // 商家备注存储
        ramakePlus: '',
        // 是否停用 商家备注编辑
        barcodeVisible: false,
        barcodeList: [],
        // PackageVOList: [],
        activeName: 'first',
      };
    },
    computed: {
      id() {
        return this.$route.query.id || null;
      },
      code() {
        return decodeURIComponent(this.$route.query.code) || null;
      },
      SCHL_CHANNEL_TYPE() {
        return this.$store.state.values.SCHL_CHANNEL_TYPE || [];
      },
      amountInfoVO() {
        return this.info.amountInfoVO || {};
      },
      orderInfoVO() {
        return this.info.orderInfoVO || {};
      },
      paymentInfoVO() {
        return this.info.paymentInfoVO || {};
      },
      thirdItemVO() {
        return this.info.thirdItemVO || [];
      },
      packageVO() {
        return this.info.packageVO || [];
      },
      SELECTED_BJ_EBC_ID() {
        return this.multipleSelection.map(e => e.id);
      },
      totalSkuNum() {
        return this.thirdItemVO.reduce((pre, cur) => (pre += Number(cur.quantity)), 0);
      }
    },
    watch: {
      'info.orderInfoVO.shippingMethod': {
        handler() {
          this.$nextTick(() => {
            if (!this.$refs.UploadFileRef1 || !this.info.orderInfoVO.shippingLabels) return;
            this.$refs.UploadFileRef1.fileList = this.info.orderInfoVO.shippingLabels
            
            if (!this.$refs.UploadFileRef2 || !this.info.orderInfoVO.orderMaterialList) return;
            this.$refs.UploadFileRef2.fileList = this.info.orderInfoVO.orderMaterialList.map(item=>{
              return {
                name: item.fileName,
                url: item.fileUrl
              };
            });
          });
        }
      },
    },
    created() {
      this.totalOrderStatus = this.$route.query.status;
    },
    mounted() {
      this.reFresh();
    },
    methods: {
      /**
       * 格式化运单文件数据
       * @param {Array} shippingLabels - 运单文件数组
       * @returns {string} 格式化后的JSON字符串或空字符串
       */
      formatShippingLabels(shippingLabels) {
        return shippingLabels && Array.isArray(shippingLabels) && shippingLabels.length > 0 
          ? JSON.stringify(shippingLabels) 
          : '';
      },
      onView(row){
        this.barcodeList = row.batchNumList
        this.barcodeVisible = true
      },
      // 标红
      rowStyleFun({ row }) {
        const styleJson = {};
        if(!!row.needExpired && (row.spuCode && row.batchNumList && row.batchNumList.bjGet(row.spuCode, 'value', 'usableNum') < row.quantity || row.batchNumTotal < row.quantity)){
          styleJson.color = 'red';
        }
        return styleJson;
      },
      logsome(v, item) {
        this.orderInfoVO.logisticsCompany = v ? item.label: '';
      },
      onShippingMethod(val) {
        // this.fileList = this.info.orderInfoVO.orderMaterialList.map(item=>{
        //   return {
        //     name: item.fileName,
        //     url: item.fileUrl
        //   };
        // });
        this.orderInfoVO.logisticsBusinessName = null;
        this.orderInfoVO.logisticsNo = null;
        this.info.orderInfoVO.logisticsCompany = null;
        this.orderInfoVO.isLogisticsSpecified = ['Standard Shipping', 'Express Shipping'].includes(val)
          ? this.originalIsLogisticsSpecified == 1
          : false;
        this.orderInfoVO.isProvideSize = false;
        this.orderInfoVO.palletQty = null;
        this.orderInfoVO.truckPickupTime = null;
        this.orderInfoVO.deliveryAppointmentTime = null;
        this.orderInfoVO.logisticsName = null;
        this.orderInfoVO.buyerRemarks = '';
        if (val == 'CSG MANUAL') {
          this.orderInfoVO.isLogisticsSpecified = true;
          this.orderInfoVO.buyerRemarks = 'CSG manual booking';
        } else if (val === 'CUSTOMER MANUAL') {
          this.orderInfoVO.buyerRemarks = 'Shipping label print';
        }
        this.getLogisticsDataList(val)
      },
      // 获取 物流询价 信息
      getLogisticsInfo() {
        thirdApi.getOutOrderLogisticsInfo({orderCode: this.code}).then(res => {
          if (Array.isArray(res)) {
            this.logisticsInfo = res;
          }
        });
      },
      // 获取物流下拉信息
      async getLogisticsDataList(val) {
        logisticApi.getLogisticsBusiness({
          enableFlag: null,
          csgEnableFlag: val=='CSG MANUAL' ? true: null,
          currentPage: 0,
          page: 0,
          pagesize: 999,
          size: 999,
        }).then(res => {
          this.LogisticsSelectionData = res.content.map(item => {
            return {
              label: item.logisticsName,
              value: item.name
            };
          });
        });
      },
      // 单独删除
      onDelete(row) {
        this.$confirm(this.$t('SalesOrderEntry.form.want'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(() => {
          const index = this.info.thirdItemVO.findIndex(e => e.id == row.id);
          if (index > -1) this.info.thirdItemVO.splice(index, 1);
          this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
        });
      },
      // 批量删除
      onBatchDelete() {
        this.$confirm(this.$t('SalesOrderEntry.form.sure'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(() => {
          this.SELECTED_BJ_EBC_ID.forEach(id => {
            const index = this.info.thirdItemVO.findIndex(e => e.id == id);
            if (index > -1) this.info.thirdItemVO.splice(index, 1);
          });
          this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
        });
      },
      // 添加商品
      onAddSome() {
        this.$refs['dialogListOrdinarySku'].show();
      },
      // 添加套餐
      onAddMore() {
        this.$refs['dialogListPackAgeSku'].show();
      },
      // 保存
      onSave() {
        // let bstop = true;
        let badMsg = true;
        const duplicates = new Map();
        const newArr = [];
        if(this.info.thirdItemVO.length == 0) return this.$message.warning(this.$t('BusinessPurchaseOrder2.dialog.errMsg4'))
        this.info.thirdItemVO.forEach(item => {
          if(!item.quantity){ badMsg = false}
          const key = `${item.standardSkuCode}-${item.spuCode}`;
          if (duplicates.has(key)) {
              newArr.push(item);
          } else {
              duplicates.set(key, true);
          }
          // if(item.spuCode && item.quantity > item.batchNumList.bjGet(item.spuCode, 'value', 'usableNum')){
          //   bstop = false
          // };
        })
        if(newArr.length > 0) return this.$message.warning(`${newArr[0].standardSkuCode} ${this.$t('dataDuplication')}`)
        if(!badMsg) return this.$message.warning(this.$t('SalesOrderEntry.form.Qty'))
        // if(!bstop) this.$message.error('Quantity > Available')
        afterApi.editThirdOrderGoods({id: this.info.orderInfoVO.id, thirdItemVO: this.info.thirdItemVO}).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('SalesOrderEntry.form.Submitted'));
            this.isShow = !this.isShow;
            this.reFresh();
          }
        });
      },
      // 列表选中数据返回
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 添加商品后返回
      onAddGoodsDialogConfirm(data) {
        if (data && !data[0].id) return;
        let promise = Promise.resolve();
        data.forEach(async(item) => {
          // if (!this.info.thirdItemVO.find(ee => ee.skuCode == item.skuCode)) {
            promise = promise.then(() => {
              return new Promise(resolve => {
                orderApi.selectSkuCodeBatch({skuCode: item.skuCode,cusId:this.$store.getters.cusId}).then(async resp=>{
                  this.info.thirdItemVO.push({
                    // id 批量删除用
                    id: item.id,
                    // 以下四个值 列表展示用
                    innerSkuCode: item.standardSkuCode,
                    quantity: item.qty || 1,
                    skuName: item.skuName,
                    skuCode: item.skuCode,
                    spuCode: item.spuCode,
                    innerSkuName: item.skuName,
                    standardSkuCode: item.standardSkuCode,
                    batchNumList: resp.map(item=>{return { //批次号
                        ...item, value: item.batchNum, label: item.batchNum, usableNum:item.usableNum, bbd:item.bbd
                    }}),
                  });
                  resolve();
                })
              })
            })
          // }
        });
      },
      showOrderInfoVOEdit() {
        // 保存原始数据副本
        this.copyOrderInfoVO = JSON.parse(JSON.stringify(this.info.orderInfoVO));
        this.isOrderInfoVOEdit = true;
        if (this.info.orderInfoVO.shippingLabels.length > 0) {
          this.$nextTick(() => {
            if (!this.$refs.UploadFileRef1) return;
            this.$refs.UploadFileRef1.fileList = this.info.orderInfoVO.shippingLabels
          });
        }
        if (this.info.orderInfoVO.orderMaterialList.length > 0) {
          this.$nextTick(() => {
            if (!this.$refs.UploadFileRef2) return;
            this.$refs.UploadFileRef2.fileList = this.info.orderInfoVO.orderMaterialList.map(item=>{
              return {
                name: item.fileName,
                url: item.fileUrl
              };
            });
          });
        }
      },
      // 取消 按钮
      cancelOrderInfoVOEdit() {
        //原始数据
        if (this.copyOrderInfoVO && Object.keys(this.copyOrderInfoVO).length > 0) {
          this.info.orderInfoVO = JSON.parse(JSON.stringify(this.copyOrderInfoVO));
        }
        // 重置编辑状态
        this.isOrderInfoVOEdit = false;
        // 重置文件上传组件
        this.$nextTick(() => {
          if (this.$refs.UploadFileRef1) {
            this.$refs.UploadFileRef1.fileList = this.info.orderInfoVO.shippingLabels || [];
          }
          if (this.$refs.UploadFileRef2) {
            this.$refs.UploadFileRef2.fileList = this.info.orderInfoVO.orderMaterialList?.map(item => ({
              name: item.fileName,
              url: item.fileUrl
            })) || [];
          }
        });
      },
      // 运单文件
      fileListChange1(file) {
        if(file.length > 0){
          this.info.orderInfoVO.shippingLabels = file.map(item => { return {name: item.name,  url: item.url}}).filter(item => item.url);
        }else{
          this.info.orderInfoVO.shippingLabels = []
        }
      },
      // 其他文件 
      fileListChange2(file) {
        if(file.length > 0){
          this.info.orderInfoVO.orderMaterialList = file.map(item => { return {fileName: item.name,  fileUrl: item.url}}).filter(item => item.fileUrl);
        }else{
          this.info.orderInfoVO.orderMaterialList = []
        }
      },
      countryData(val) {
        this.info.receiverInfoVO.country = val[0]?.label;
        this.info.receiverInfoVO.province = val[1]?.label;
      },
      onEditReceiverInfo() {
        this.isReciverEdit = true;
        this.copyReceiverInfo = JSON.parse(JSON.stringify(this.info.receiverInfoVO));
      },
      cancelReceiverInfo() {
        this.isReciverEdit = false;
        this.info.receiverInfoVO = this.copyReceiverInfo;
      },
      getIsLogisticsSpecified() {
        // Standard / Express 始终提交详情接口的原值，MANUAL 保留现有编辑逻辑。
        if (['Standard Shipping', 'Express Shipping'].includes(this.info.orderInfoVO.shippingMethod)) {
          return this.originalIsLogisticsSpecified;
        }
        return this.info.orderInfoVO.isLogisticsSpecified ? 1 : 0;
      },
      saveReceiverInfo(newReceiverInfo, closeDialog) {
        if (newReceiverInfo) {
          this.info.receiverInfoVO = Object.assign({}, this.info.receiverInfoVO, newReceiverInfo);
        }
        const receiverInfoVO = this.info.receiverInfoVO;
        const countryList = ['TW','HK','MO','SG','GB','IE','IL','IS','AE','MC','BH','VA','SZ','MV','NZ','SM','LI','AD','BS']
        const regex = /^[A-Za-z0-9 \-\'\.,\/#&:;()]+$/
        if ( this.info.orderInfoVO.shippingMethod != 'PICKUP' ){
          if (!receiverInfoVO.receiverName) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryName')}${this.$t('emptyWarningText')}`);
          if (!receiverInfoVO.phone) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryPhone')}${this.$t('emptyWarningText')}`);
          if (!receiverInfoVO.country) return this.$message.warning(`${this.$t('WarehouseManagement.form.country')}${this.$t('emptyWarningText')}`);
          if (!receiverInfoVO.province && !countryList.includes(receiverInfoVO.country)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryState')}${this.$t('emptyWarningText')}`);
          if (receiverInfoVO.province && !regex.test(receiverInfoVO.province)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryState')}${this.$t('IncorrectAddressFormatText')}`);
          if (!receiverInfoVO.district) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliverySuburb')}${this.$t('emptyWarningText')}`);
          if (receiverInfoVO.district && !regex.test(receiverInfoVO.district)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliverySuburb')}${this.$t('IncorrectAddressFormatText')}`);
          if (!receiverInfoVO.zipCode) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryPostcode')}${this.$t('emptyWarningText')}`);
          if (!receiverInfoVO.deliveryAddress1) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress1')}${this.$t('emptyWarningText')}`);
          if (receiverInfoVO.deliveryAddress1 && !regex.test(receiverInfoVO.deliveryAddress1)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress1')}${this.$t('IncorrectAddressFormatText')}`);
          // if (!receiverInfoVO.deliveryAddress2) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress2')}${this.$t('emptyWarningText')}`);
          if (receiverInfoVO.deliveryAddress2 && !regex.test(receiverInfoVO.deliveryAddress2)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress2')}${this.$t('IncorrectAddressFormatText')}`);
          if (receiverInfoVO.deliveryEmailAddress) {
            if (!receiverInfoVO.deliveryEmailAddress.includes('@')) return this.$message.warning(this.$t('personal.emailErrorMsg2'));
          }
        }else{
          if (!receiverInfoVO.receiverName) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryName')}${this.$t('emptyWarningText')}`);
          if (!receiverInfoVO.phone) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryPhone')}${this.$t('emptyWarningText')}`);
          if (!receiverInfoVO.country) return this.$message.warning(`${this.$t('WarehouseManagement.form.country')}${this.$t('emptyWarningText')}`);
          
          if (receiverInfoVO.province) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryState')} ： ${this.$t('ExternalOrders.addressTips')}`);
          if (receiverInfoVO.district) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliverySuburb')} ： ${this.$t('ExternalOrders.addressTips')}`);
          if (receiverInfoVO.zipCode) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryPostcode')} ： ${this.$t('ExternalOrders.addressTips')}`);
          if (receiverInfoVO.deliveryAddress1) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress1')} ： ${this.$t('ExternalOrders.addressTips')}`);
          if (receiverInfoVO.deliveryAddress2) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress2')} ： ${this.$t('ExternalOrders.addressTips')}`);
          if (receiverInfoVO.deliveryEmailAddress) {
            if (!receiverInfoVO.deliveryEmailAddress.includes('@')) return this.$message.warning(this.$t('personal.emailErrorMsg2'));
          }
        }

        const formattedShippingLabels = this.formatShippingLabels(this.info.orderInfoVO.shippingLabels);
                
        return orderApi.modifyThirdOrder({
          ...this.info,
          orderInfoVO: {
            ...this.info.orderInfoVO, 
            isLogisticsSpecified: this.getIsLogisticsSpecified(),
            shippingLabels: formattedShippingLabels,
          },
        }).then(res => {
          if (!res || res.failed) return false;
          this.reFresh();
          this.isReciverEdit = false;
          // 如果订单信息编辑状态也开着，则关闭并重置
          if (this.isOrderInfoVOEdit) {
            this.isOrderInfoVOEdit = false;
            this.copyOrderInfoVO = {};
          }
          // 验证通过，关闭弹窗
          closeDialog && closeDialog();
          return true;
        }).catch(() => false);
      },
      saveOrderInfoVO() {
        // 老CUSTOMER MANUAL逻辑
        // if(this.info.orderInfoVO.shippingMethod === 'CUSTOMER MANUAL'){
        //   if(this.info.orderInfoVO.logisticsNo && !this.info.orderInfoVO.logisticsBusinessName) return this.$message.error(this.$t('BusinessPurchaseComponentsCom.rules.logisticsBusinessId'));
        //   if(this.info.orderInfoVO.orderMaterialList.length>0 && !this.info.orderInfoVO.logisticsBusinessName) return this.$message.error(this.$t('BusinessPurchaseComponentsCom.rules.logisticsBusinessId'));
        //   if(this.info.orderInfoVO.orderMaterialList.length>0 && this.info.orderInfoVO.isProvideSize == true){this.info.orderInfoVO.isProvideSize = false};
        // }

        // 新CUSTOMER MANUAL逻辑
        if(this.info.orderInfoVO.shippingMethod == 'CUSTOMER MANUAL'){
          // 若不需要仓库提供尺寸信息 则此处 Courier Service，Job Id/Tracking No.，Shipping Label都应为必填
          if(this.info.orderInfoVO.isProvideSize == false){
            if(!this.info.orderInfoVO.logisticsBusinessName || this.info.orderInfoVO.logisticsBusinessName.trim() === ""){
              return this.$message.error(`${this.$t('inputText')} ： ${this.$t('WarehouseManagement.form.chooseLogistics')}`);
            }
            if(!this.info.orderInfoVO.logisticsNo || this.info.orderInfoVO.logisticsNo.trim() === ""){
              return this.$message.error(`${this.$t('inputText')} ： ${this.$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')}`);
            }
            if(this.info.orderInfoVO.shippingLabels.length==0){
              return this.$message.error(`${this.$t('chooseText')} ： ${this.$t('OrdinaryOrderMix.LogisticsTable.Shipment')}`);
            }
          }
          // 如果Courier Service，Job Id/Tracking No.，Shipping Label任意一个有值，那么另外两个都必填
          if((this.info.orderInfoVO.logisticsBusinessName&&this.info.orderInfoVO.logisticsBusinessName.trim() !== "") || (this.info.orderInfoVO.logisticsNo&&this.info.orderInfoVO.logisticsNo.trim() !== "") || this.info.orderInfoVO.shippingLabels.length!=0){
            if(!this.info.orderInfoVO.logisticsBusinessName || this.info.orderInfoVO.logisticsBusinessName.trim() === ""){
              return this.$message.error(`${this.$t('inputText')} ： ${this.$t('WarehouseManagement.form.chooseLogistics')}`);
            }
            if(!this.info.orderInfoVO.logisticsNo || this.info.orderInfoVO.logisticsNo.trim() === ""){
              return this.$message.error(`${this.$t('inputText')} ： ${this.$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')}`);
            }
            if(this.info.orderInfoVO.shippingLabels.length==0){
              return this.$message.error(`${this.$t('chooseText')} ： ${this.$t('OrdinaryOrderMix.LogisticsTable.Shipment')}`);
            }
          }
          // 老逻辑保留
          if(this.info.orderInfoVO.shippingLabels.length>0 && this.info.orderInfoVO.isProvideSize == true){this.info.orderInfoVO.isProvideSize = false};
        }
        const orderInfoVO = {
          buyerRemarks: this.info.orderInfoVO.buyerRemarks,
          orderRemarks: this.info.orderInfoVO.orderRemarks,
          serviceRemarks: this.info.orderInfoVO.serviceRemarks,
          outerOrderNo: this.info.orderInfoVO.outerOrderNo,
          id: this.info.orderInfoVO.id,
          shippingMethod: this.info.orderInfoVO.shippingMethod,
          isLogisticsSpecified: this.getIsLogisticsSpecified(),
          isNeedQuota: this.info.orderInfoVO.isNeedQuota,
          isProvideSize: this.info.orderInfoVO.isProvideSize,
          palletQty: this.info.orderInfoVO.palletQty,
          truckPickupTime: this.info.orderInfoVO.truckPickupTime ? moment(this.info.orderInfoVO.truckPickupTime).format('YYYY-MM-DD HH:mm:ss') : null,
          deliveryAppointmentTime: this.info.orderInfoVO.deliveryAppointmentTime ? moment(this.info.orderInfoVO.deliveryAppointmentTime).format('YYYY-MM-DD HH:mm:ss') : null,
          logisticsName: this.info.orderInfoVO.logisticsName,
          logisticsBusinessName: this.info.orderInfoVO.logisticsBusinessName,
          logisticsNo: this.info.orderInfoVO.logisticsNo,
          logisticsCompany: this.info.orderInfoVO.logisticsCompany,
          // 运单文件 字符串化处理 - 需要先保留原始的shippingLabels
          shippingLabels: this.info.orderInfoVO.shippingLabels,
          // 其他文件
          orderMaterialList: this.info.orderInfoVO.orderMaterialList,
        };
        if (['PICKUP', 'CSG MANUAL', 'CUSTOMER MANUAL'].includes(orderInfoVO.shippingMethod)) {
          orderInfoVO.takingDeliveryWay = 1;
        }
        if (['Standard Shipping', 'Express Shipping'].includes(orderInfoVO.shippingMethod)) {
          orderInfoVO.takingDeliveryWay = 2;
        }
        const formattedShippingLabels = this.formatShippingLabels(orderInfoVO.shippingLabels);
        
        const POST_DATA = {
          ...this.info,
          orderInfoVO: {
            ...orderInfoVO,
            shippingLabels: formattedShippingLabels,
          },
        };
        return orderApi.modifyThirdOrder(POST_DATA).then(res => {
          if (!res || res.failed) return false;
          this.reFresh();
          this.isOrderInfoVOEdit = false;
          // 保存成功后清理副本数据
          this.copyOrderInfoVO = {};
          // 如果收货信息编辑状态也开着，则关闭并重置
          if (this.isReciverEdit) {
            this.isReciverEdit = false;
            this.copyReceiverInfo = {};
          }
          return true;
        }).catch(() => false);
      },
      showLog() {
        orderLog(
          this.$BjDialogListConfig['orderLogDefault'](` ${this.orderInfoVO.webReference} `, {
            defaultQuery: {
              outerOrderNo: this.code,
            },
            search: [],
          }),
        );
      },
      reFresh() {
        orderApi.getThirdOrderDetail({ id: this.id, outerOrderNo: this.code }).then(res => {
          getShippingList(res.cusId).then(res=>{
            this.CSG_ORDER_SHIPPING_METHODS_LIST = res.filter(item=> !item.isDisable)
          })
          // 批次号
          let promise = Promise.resolve();
          res.thirdItemVO?.forEach(item =>{
            promise = promise.then(() => {
                return new Promise(resolve => {
                  orderApi.selectSkuCodeBatch({skuCode: item.skuCode,cusId: res.cusId}).then(resp=>{
                    item.batchNumList = resp.map(jitem=>{return {
                      ...jitem, value: jitem.batchNum, label: jitem.batchNum, usableNum:jitem.usableNum, bbd:jitem.bbd
                    }})
                    item.batchNumTotal = item.batchNumList.reduce((pre, cur) => (pre += cur.usableNum), 0);
                    resolve();
                  })
                })
            })
          })
          return promise.then(() => {
            this.getLogisticsDataList(res.orderInfoVO.shippingMethod);
            res.receiverInfoVO = res.receiverInfoVO || getDefaultForm().receiverInfoVO;
            res.orderInfoVO.shippingLabels = res.orderInfoVO.shippingLabels ? JSON.parse(res.orderInfoVO.shippingLabels) : [];
            res.orderInfoVO.orderMaterialList = res.orderInfoVO.orderMaterialList || [];
            this.originalIsLogisticsSpecified = res.orderInfoVO.isLogisticsSpecified == 1 ? 1 : 0;
            res.orderInfoVO.isLogisticsSpecified = this.originalIsLogisticsSpecified == 1;
            res.orderInfoVO.isProvideSize = !!res.orderInfoVO.isProvideSize;
            res.orderInfoVO.deliveryAppointmentTime = res.orderInfoVO.deliveryAppointmentTime
              ? moment(res.orderInfoVO.deliveryAppointmentTime).format('YYYY-MM-DD HH:mm:ss')
              : null;
            this.ramakePlus = res.orderInfoVO.orderRemarks || '';
            this.info = Object.assign({}, this.info, res);
            // 判断是否显示 物流询价
            userApi.getClientCode({cusId: this.info.cusId}).then(res => {
              if (res.message == 'LRI' || res.message == 'PNT') {
                this.isLogisticsShow = true;
                this.getLogisticsInfo();
              }
            });
          });
        });
      },
      /* 关闭弹窗 */
      handleClose() {
        this.cancel();
        // if([5,6].includes(this.$route.query.status)){
        //   this.complete('BusinessOrderInternalCSGAdmin');
        // }else{
        //   this.complete('BusinessAbnormalOrderALL');
        // }
      },
    },
  };
  </script>
  <style lang="scss" scoped>
.app-container .bj-form-item .order-remark-content {
  display: flex;
  align-items: center;
  min-width: 0;
}
.order-remark-content .order-remark-text {
  flex: 0 1 auto;
  width: auto;
  max-width: 75%;
  min-width: 0;
}
.order-remark-copy {
  flex: 0 0 auto;
  margin-left: 10px;
}
.app-container {
  width: 100%;
}
.circulation-status {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding-bottom: 16px;
  .el-icon-circle {
    margin-right: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 52px;
  }
}
.bj-formItemLabel {
  max-width: 20em !important;
}
div:not(.bj-page) .bj-row .bj-col {
  width: 49.33%;
}
.file {
  display: flex;
  font-size: 12px !important;
}
.file .fileUpload {
  margin-left: 10px;
  line-height: 15px;
  color: #6c6c6c;
}
.fileUpload_right {
  display: flex;
}
.ellipsis {
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 250px;
  margin-left: 5px;
}
::v-deep .avatar-uploader .el-upload {
  border: none;
}
.fileUpload2 {
  margin: 10px 10px 0;
}
</style>
